<script>
import {defineComponent} from 'vue'
import {Link} from "@inertiajs/vue3";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";
import 'swiper/css/pagination'

export default defineComponent({
    name: "HomeCategoryLinks",
    components: {
        OnlyMobile,
        OnlyDesktop,
        Link,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            swiper: null,
        }
    },
    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance;
        },
    },
})
</script>

<template>
    <OnlyDesktop :maxSize="480" class="h-full">
        <div class="grid grid-cols-2 md:grid-cols-2 gap-4 h-full">
            <Link :href="route('catalog',{category_title:'priyom_chernogo_metalla'})"
                  class="bg-grayBg chermet-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Приём черного металла
                    </p>
                    <p class="md:text-gray-800 text-xs font-normal max-w-[70%] md:max-w-[65%] leading-tight">
                        Принимаем лом стали и чугуна. Быстрая оценка и честный расчёт.
                    </p>
                </div>
            </Link>

            <Link :href="route('catalog',{category_title:'priyom_tsvetnogo_metalla'})"
                  class="bg-grayBg cvetmet-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Приём цветного металла
                    </p>
                    <p class="md:text-gray-800 text-xs font-normal max-w-[70%] md:max-w-[65%] leading-tight">
                        Скупка меди, алюминия и латуни с расчётом в день обращения.
                    </p>
                </div>
            </Link>

            <Link :href="route('catalog',{category_title:'priyom_elektrodvigateley'})"
                  class="bg-grayBg elektrogenerator-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Приём электродвигателей
                    </p>
                    <p class="md:text-gray-800 text-xs font-normal max-w-[70%] md:max-w-[65%] leading-tight">
                        Принимаем электродвигатели и моторы на лом с высоким содержанием меди.
                    </p>
                </div>
            </Link>

            <Link :href="route('catalog',{category_title:'priyom_kabelya'})"
                  class="bg-grayBg kabel-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Приём кабеля
                    </p>
                    <p class="md:text-gray-800 text-xs font-normal max-w-[70%] md:max-w-[65%] leading-tight">
                        Скупка медного и алюминиевого кабеля. Быстрый расчёт.
                    </p>
                </div>
            </Link>

            <Link :href="route('catalog',{category_title:'priyom_akkumulyatorov'})"
                  class="bg-grayBg akb-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Приём аккумуляторов
                    </p>
                    <p class="md:text-gray-800 text-xs font-normal max-w-[70%] md:max-w-[65%] leading-tight">
                        Приём свинцовых аккумуляторов с соблюдением норм.
                    </p>
                </div>
            </Link>

            <Link :href="route('catalog',{category_title:'priyom_transformatorov'})"
                  class="bg-grayBg transformator-bg bg-no-repeat bg-contain border-2 border-gray-100 rounded-lg px-2 md:px-4 py-4 relative md:hover:shadow-sm md:hover:border-baseColor max-md:active:border-baseColor transition">
                <div class="bg-no-repeat w-full h-full">
                    <p class="mb-4 font-semibold leading-tight">
                        Приём трансформаторов
                    </p>
                    <p class="md:text-gray-800 text-xs font-normal max-w-[70%] md:max-w-[65%] leading-tight">
                        Скупка трансформаторов и электротехники по актуальным ценам.
                    </p>
                </div>
            </Link>
        </div>
    </OnlyDesktop>

    <OnlyMobile :maxSize="480">
        <div class="w-full overflow-hidden">
            <Swiper :slides-per-view="'auto'" :space-between="18" class="!overflow-visible cursor-grab">
                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'priyom_chernogo_metalla'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/categories/small/priyom_chernogo_metalla.webp" alt="Чермет"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Приём черного<br/> металлалома
                    </Link>
                </SwiperSlide>

                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'priyom_tsvetnogo_metalla'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/categories/small/priyom_tsvetnogo_metalla.webp" alt="Цветмет"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Приём цветного<br/> металлалома
                    </Link>
                </SwiperSlide>

                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'priyom_metallov_rzm'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/categories/small/priyom_metallov_rzm.webp" alt="РЗМ"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Приём РЗМ<br/> металлалома
                    </Link>
                </SwiperSlide>

                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'priyom_kabelya'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/categories/small/priyom_kabelya.webp" alt="Приём кабеля"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Приём лома<br/> кабеля
                    </Link>
                </SwiperSlide>

                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'priyom_akkumulyatorov'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/categories/small/priyom_akkumulyatorov.webp" alt="Приём аккумуляторов"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Приём лома<br/> аккумуляторов
                    </Link>
                </SwiperSlide>

                <SwiperSlide class="!w-auto">
                    <Link :href="route('catalog',{category_title:'priyom_transformatorov'})"
                          class="flex flex-col gap-2 items-center font-semibold text-xs text-center leading-tight">
                        <img src="@img/categories/small/priyom_transformatorov.webp" alt="Приём трансформаторов"
                             class="w-12 h-12 rounded-lg object-contain"/>
                        Приём лома<br/> трансформаторов
                    </Link>
                </SwiperSlide>
            </Swiper>
        </div>
    </OnlyMobile>
</template>

<style scoped lang="scss">
@media (min-width: 480px) {
    .chermet-bg {
        background-image: url("@img/categories/bg/chermet.png");
        background-size: contain;
        background-position: right bottom;
    }

    .cvetmet-bg {
        background-image: url("@img/categories/bg/cvetmet.png");
        background-size: contain;
        background-position: right bottom;
    }

    .elektrogenerator-bg {
        background-image: url("@img/categories/bg/elektrogenerator.png");
        background-size: contain;
        background-position: right bottom;
    }

    .kabel-bg {
        background-image: url("@img/categories/bg/kabel.png");
        background-size: contain;
        background-position: right bottom;
    }

    .akb-bg {
        background-image: url("@img/categories/bg/akb.png");
        background-size: contain;
        background-position: right bottom;
    }

    .transformator-bg {
        background-image: url("@img/categories/bg/transformator.png");
        background-size: contain;
        background-position: right bottom;
    }
}
</style>
